// src/data/projectsData.js

// ── Personal project images ───────────────────────────────────────────────────
import pro1 from "../Pages/img/pro1.png";
import pro2 from "../Pages/img/pro2.png";
import pro3 from "../Pages/img/pro3.png";
import pro4 from "../Pages/img/pro4.png";

// ── Work / client project images ─────────────────────────────────────────────
// Drop screenshots in src/Pages/img/ and uncomment each line:
// import work1  from "../Pages/img/work1.png";   // Reel Paraphraser
// import work2  from "../Pages/img/work2.png";   // Caption Paraphraser
// import work3  from "../Pages/img/work3.png";   // Script Generator
// import work4  from "../Pages/img/work4.png";   // Caption Generator
// import work5  from "../Pages/img/work5.png";   // Audio Tags
// import work6  from "../Pages/img/work6.png";   // Thumbnail Hooks
// import work7  from "../Pages/img/work7.png";   // Ads Copy
// import work8  from "../Pages/img/work8.png";   // VPS Generator
// import work9  from "../Pages/img/work9.png";   // Content Creation System
// import work10 from "../Pages/img/work10.png";  // Persona Generator
// import work11 from "../Pages/img/work11.png";  // Client Onboarding

// ── Personal projects ─────────────────────────────────────────────────────────
export const projects = [
  {
    title: "Kilowhatt?",
    year: "2025",
    role: "Mobile App • Full-stack",
    img: pro1,
    live: "https://www.kilowhatt.space/",
    repo: "https://github.com/NLGtan/kilowhatt_app",
    description:
      "A Flutter mobile app connecting homeowners and tenants. It includes role-based dashboards, bill tracking, OCR-based submeter reading, push notifications, and Supabase image uploads. The app also integrates a blockchain payment method to ensure secure, immutable bill records.",
    stack: ["Flutter", "Firebase", "Supabase"],
    flip: false,
  },
  {
    title: "PANIK",
    year: "2026",
    role: "Web3 • Full-stack",
    img: pro2,
    live: "https://www.panik.fi/",
    repo: "https://github.com/NLGtan/Panik",
    description:
      "A non-custodial, atomic DeFi emergency exit protocol on Base. Enables users to exit multiple open lending and LP positions (like Aave V3 and Uniswap V3) in a single transaction with pre-flight lock detection and real-time position health tracking.",
    stack: ["React", "Solidity", "Wagmi"],
    flip: true,
  },
  {
    title: "Axari",
    year: "2025",
    role: "Web Design • Frontend",
    img: pro3,
    live: "https://axari.vercel.app/",
    repo: "",
    description:
      "An immersive Web3 marketing site showcasing modern frontend craftsmanship. It blends fluid motion, layered parallax visuals, and responsive typography to create a sleek, interactive experience with premium UI design.",
    stack: ["React", "Tailwind", "Framer Motion"],
    flip: false,
  },
  {
    title: "VoidMark",
    year: "2026",
    role: "Web3 • Full-stack",
    img: pro4,
    live: "https://void-mark.vercel.app/",
    repo: "https://github.com/NLGtan/stellar",
    description:
      "A professional-grade NFT gallery, marketplace, and off-chain quarterly reward system built on Base. Features a peer-to-peer marketplace with PHP-based pricing and live ETH conversion, plus a custom rarity-weighted USDC reward model.",
    stack: ["Next.js", "Node.js", "Supabase", "PostgreSQL"],
    flip: true,
  },
];

// ── Work / client projects ────────────────────────────────────────────────────
// All 11 tools from the client's content platform — private company work
export const workProjects = [
  {
    title: "Reel Paraphraser",
    year: "2025",
    role: "Content Tool • Frontend",
    img: null,
    live: "",
    repo: "",
    description:
      "Internal rewrite tool built for the marketing team to turn one reel script into multiple platform-ready variations while preserving the core message. Replaced repetitive manual rewriting with a faster workflow that typically reduced per-script rewrite time from roughly 15–20 minutes to under 3 minutes and improved content consistency across campaigns.",
    stack: ["n8n", "React", "TypeScript", "Tailwind"],
    flip: false,
  },
  {
    title: "Caption Paraphraser",
    year: "2025",
    role: "Content Tool • Frontend",
    img: null,
    live: "",
    repo: "",
    description:
      "Built to help the marketing team quickly repurpose existing captions into new tones and formats for different platforms. Turned a repetitive 10–15 minute manual rewrite task into a sub-2-minute workflow, making it easier to scale caption production without sacrificing brand voice.",
    stack: ["n8n", "React", "TypeScript", "Tailwind"],
    flip: true,
  },
  {
    title: "Script Generator",
    year: "2025",
    role: "Content Tool • Frontend",
    img: null,
    live: "",
    repo: "",
    description:
      "Generates ready-to-record short-form video scripts from a topic or creative brief, complete with hook, body, and CTA. Helped the team move from blank-page drafting to a usable first draft in under 2 minutes instead of spending roughly 30–60 minutes outlining manually.",
    stack: ["n8n", "React", "TypeScript", "Tailwind"],
    flip: false,
  },
  {
    title: "Caption Generator",
    year: "2025",
    role: "Content Tool • Frontend",
    img: null,
    live: "",
    repo: "",
    description:
      "Creates platform-optimized captions from a topic or video summary, including hashtags, emojis, and CTAs tailored for Instagram, TikTok, and YouTube Shorts. Reduced caption drafting time from around 10–15 minutes to under 2 minutes per post while keeping formatting more consistent across channels.",
    stack: ["n8n", "React", "TypeScript", "Tailwind"],
    flip: true,
  },
  {
    title: "Audio Tags",
    year: "2025",
    role: "SEO Tool • Frontend",
    img: null,
    live: "",
    repo: "",
    description:
      "Generates niche-relevant audio and sound tags for short-form video content to support discoverability and faster publishing. Cut manual tag research from roughly 5–10 minutes per post to under a minute, helping the team publish faster with more targeted metadata.",
    stack: ["n8n", "React", "TypeScript", "Tailwind"],
    flip: false,
  },
  {
    title: "Thumbnail Hooks",
    year: "2025",
    role: "Content Tool • Frontend",
    img: null,
    live: "",
    repo: "",
    description:
      "Produces high-CTR thumbnail text ideas and visual hook concepts for YouTube and short-form content. Replaced slow brainstorming sessions with instant batches of headline options, cutting ideation time from roughly 20 minutes to under 3 minutes and giving the team more angles to test.",
    stack: ["n8n", "React", "TypeScript", "Tailwind"],
    flip: true,
  },
  {
    title: "Ads Copy",
    year: "2025",
    role: "Marketing Tool • Frontend",
    img: null,
    live: "",
    repo: "",
    description:
      "Generates objective-based ad copy for awareness, traffic, and conversion campaigns, including headlines, primary text, and CTAs. Helped reduce first-draft copy creation from around 20–30 minutes to under 5 minutes per campaign angle while making ad production more repeatable.",
    stack: ["n8n", "React", "TypeScript", "Tailwind"],
    flip: false,
  },
  {
    title: "VPS Generator",
    year: "2025",
    role: "Strategy Tool • Frontend",
    img: null,
    live: "",
    repo: "",
    description:
      "Creates a clear Value Proposition Statement by distilling the audience, core benefit, and differentiator into one sharp message. Compressed a strategy task that usually took 30–45 minutes of manual refinement into a focused 2–3 minute workflow, giving the team a stronger starting point for content and ads.",
    stack: ["n8n", "React", "TypeScript", "Tailwind"],
    flip: true,
  },
  {
    title: "Content Creation System",
    year: "2025",
    role: "Workflow Tool • Frontend",
    img: null,
    live: "",
    repo: "",
    description:
      "A structured planning system that turns one niche or campaign goal into content pillars, topic clusters, and posting cadence. Reduced what was often a 1–2 hour planning process into a repeatable workflow completed in minutes, making content strategy faster to build and easier to scale.",
    stack: ["n8n", "React", "TypeScript", "Tailwind"],
    flip: false,
  },
  {
    title: "Persona Generator",
    year: "2025",
    role: "Strategy Tool • Frontend",
    img: null,
    live: "",
    repo: "",
    description:
      "Builds detailed audience personas from a niche or product description, including pain points, goals, content preferences, and buying triggers. Reduced research synthesis time from roughly 30 minutes to under 5 minutes and gave the marketing team a reusable messaging reference for campaigns.",
    stack: ["n8n", "React", "TypeScript", "Tailwind"],
    flip: true,
  },
  {
    title: "Client Onboarding",
    year: "2025",
    role: "Operations Tool • Frontend",
    img: null,
    live: "",
    repo: "",
    description:
      "A structured onboarding flow that collects brand details, goals, audience data, and content direction in one place. Replaced scattered back-and-forth collection with a standardized intake process, reducing onboarding prep time from roughly 45 minutes to about 10 minutes and feeding cleaner inputs into the rest of the tool suite.",
    stack: ["n8n", "React", "TypeScript", "Tailwind"],
    flip: false,
  },
];